import { createEntity, fetchEntities, upsertEntity } from 'actions/entities';
import EntitiesList from 'components/entities/EntitiesList';
import OfficeForm from 'components/offices/OfficeForm'
import OfficesListItem from 'components/superuser/offices/OfficesListItem'
import { connect } from 'react-redux'

import { getOffices } from 'selectors/offices'
import { Card } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getOffices(state, ownProps),
    entityName: 'office',
    item: OfficesListItem,
    form: OfficeForm,
    listComponent: Card.Group,
    loading: state.meta.office.loading,
    error: state.meta.office.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('offices'))
    },
    upsertEntity: (entityId) => {
      dispatch(upsertEntity('office', entityId))
    },
    createEntity: () => {
      dispatch(createEntity('office'))
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
